import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import parse, { domToReact } from 'html-react-parser';
import styled from 'styled-components';
import { get } from 'lodash';

import { exercisePropTypes } from '../../../../constants/exercise';
import ActionChip from '../../../action-chip';
import { Question } from './../../../exercise/components';
import { parseElement } from '../../../../lib/exercise';
import ChoiceChip from '../../../choice-chip';
import { parseMfenced } from '../../../../lib/utils';

const Wrapper = styled.span`
    margin: 8px;
`;

export const ChipsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
`;

const ActionChipWrapper = styled.div`
    max-width: 100%;
    margin: 8px;
`;

const Divider = styled.hr`
    width: 100%;
`;

const DragDropQuestion = ({ answers, exercise, solution = false }) => {
    let question = exercise.question.replace(/<gap_ref (.*?)\/>/g, '<gap_ref $1></gap_ref>');
    const [gapsMapping, setGapsMapping] = useState(new Map());
    useEffect(() => {
        setGapsMapping(parseElement(question, exercise.options));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const options = {
        replace: (domNode) => {
            if (domNode.name && domNode.name === 'mfenced') {
                return parseMfenced(domNode, options);
            }

            if (domNode.name && domNode.name === 'gap_ref') {
                const gapId = domNode.attribs.idref.replace('_', '');
                let responseCurrentGap = null;
                if (answers) {
                    responseCurrentGap = answers.find((item) => item.gapId === gapId);
                }

                const response = gapsMapping.get(domNode.attribs.idref) || {};

                if (responseCurrentGap) {
                    const selectedChipValue = get(
                        exercise.options.find((item) => item.id === responseCurrentGap.optionId),
                        'values[0].text',
                    );
                    return (
                        <Wrapper>
                            <ChoiceChip
                                id={responseCurrentGap.optionId}
                                value={selectedChipValue}
                                type="validated"
                                handleClick={() => {}}
                                validationType={selectedChipValue === response.text || solution ? 'success' : 'error'}
                                badgeIndex={response.char}
                            />
                        </Wrapper>
                    );
                } else {
                    return (
                        <Wrapper>
                            <ChoiceChip
                                id={response.responseId}
                                value={response.text}
                                type="validated"
                                validationType={solution ? 'success' : 'missing'}
                                badgeIndex={response.char}
                            />
                        </Wrapper>
                    );
                }
            }
        },
    };

    let parsedQuestion = parse(question, options);

    return (
        <>
            <Question>{parsedQuestion}</Question>
            {solution && (
                <>
                    <Divider />
                    <ChipsContainer>
                        {exercise.options.map((option, key) => {
                            const associatedResponse = gapsMapping.get(`_${option.id}`) || {};
                            const badgeIndex = associatedResponse.char;

                            return (
                                <ActionChipWrapper key={`${exercise.id}_${key}`}>
                                    <ActionChip
                                        badgeIndex={badgeIndex}
                                        disabled={true}
                                        id={option.id}
                                        value={option.values[0].text}
                                        handleClick={() => {}}
                                        type={badgeIndex ? 'validated' : 'listed'}
                                        validationType="missing"
                                    />
                                </ActionChipWrapper>
                            );
                        })}
                    </ChipsContainer>
                </>
            )}
        </>
    );
};

DragDropQuestion.propTypes = { ...exercisePropTypes, correctionStatus: PropTypes.object };

export default DragDropQuestion;
